import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { BaseURL, uniqueToken } from '../../api/DataApis';
import { GpsBaseURL, Role } from '../../api/DataApis';
import { Link, useNavigate } from 'react-router-dom';
import request from '../../Apis/request';
import "./User.css";
import ReactPaginate from 'react-paginate';
import Loader from "../Settings/Loader";
import Select from 'react-select';
import { getCorporateList, getFilterCategoryList } from '../../Apis/Setting';

const Company = () => {
  const [corporateData, setCorporateData] = useState([]);
  const [companyData, setCompanyData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [selectedCorporate, setSelectedCorporate] = useState("");
  const [selectcategory, setselectcategory] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [loadings, setLoadings] = useState(false);
  const [totalCount, setTotalCount] = useState(null);
  const [Limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(0);

  const navigate = useNavigate();
  document.title = "Company Discount List";

  const corporateOptions = corporateData.map(corporate => ({
    value: corporate._id,
    label: `${corporate.corporate_name} (${corporate?.email})`,
    _id: corporate._id,
  }));

  const companyOptions = companyData.map(company => ({
    value: company._id,
    label: company.company_name,
    _id: company._id,
  }));

  const categoryOptions = categoryData?.map(category => ({
    value: category._id,
    label: category?.title,
    _id: category._id,
  }));

  const fetchCorporatesData = async () => {
    try {
      const corporatesData = await getCorporateList();
      console.log("corporateData", corporatesData);
      setCorporateData(corporatesData?.data || []);
    } catch (error) {
      console.error("Error fetching corporate data:", error);
    }
  };

  const fetchCompanyData = async () => {
    try {
      const response = await axios.get(`${GpsBaseURL}/company`, {
        headers: {
          Authorization: `Bearer ${uniqueToken}`,
        },
      });
      setCompanyData(response.data?.data || []);
    } catch (error) {
      console.error("Error fetching company data:", error);
    }
  };


  const handleUpdate = async (user) => {
  if (!user.corporate_id || user.discount === "") {
    return Swal.fire("Missing Data", "Corporate and discount are required", "warning");
  }

  try {
    const res = await axios.put(`${GpsBaseURL}/company/${user._id}/discount`, {
      corporate_id: user.corporate_id,
      discount: user.discount,
    }, {
      headers: {
        Authorization: `Bearer ${uniqueToken}`,
        "Content-Type": "application/json",
      }
    });

    Swal.fire("Success", "Company discount updated successfully", "success");
    fetchproducts(page); // refresh table
  } catch (error) {
    console.error("Update error", error);
    Swal.fire("Error", "Failed to update company", "error");
  }
};


  const fetchproducts = async (page) => {
    setLoadings(true);
    let apiEndpoint = `${GpsBaseURL}/company/company-discount?page=${page}`;
    const queryParams = [];
    if (searchQuery) queryParams.push(`searchText=${searchQuery}`);
    if (selectedCorporate) queryParams.push(`corporate_id=${selectedCorporate}`);
    if (selectcategory) queryParams.push(`category_id=${selectcategory}`);
    if (queryParams.length) apiEndpoint += `&${queryParams.join('&')}`;

    try {
      const response = await axios.get(apiEndpoint, {
        headers: {
          Authorization: `Bearer ${uniqueToken}`,
        },
      });

      setFilteredData(response.data?.data || []);
      setTotalCount(response.data.count || 0);
      setLimit(response?.data?.limit || 10);
      setPageCount(Math.ceil(response.data.count / (response?.data?.limit || 10)));
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoadings(false);
    }
  };

  useEffect(() => {
    if (Role === "false") {
      fetchCorporatesData();
    }
    fetchCompanyData();
  }, [Role]);

  useEffect(() => {
    fetchproducts(page);
  }, [page]);

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    setPage(1);
    fetchproducts(1);
  };

  const handleReset = (event) => {
    event.preventDefault();
    navigate(`/company-discount-list`);
  };

  const handlecorporateChange = (selectedOption) => {
    setSelectedCorporate(selectedOption ? selectedOption._id : null);
  };

  const handlecategoryChange = (selectedOption) => {
    setselectcategory(selectedOption ? selectedOption._id : null);
  };

  const handleDelete = async (company_id, company_discount_id) => {
    if (!window.confirm("Are you sure you want to delete this company?")) return;
    try {
      await axios.delete(`${GpsBaseURL}/company/${company_id}/discount/${company_discount_id}`, {
        headers: {
          Authorization: `Bearer ${uniqueToken}`,
        },
      });
      Swal.fire("Deleted!", "Discount entry has been deleted.", "success");
      fetchproducts(page);
    } catch (err) {
      Swal.fire("Error", "Failed to delete company disocunt.", "error");
    }
  };

  const handlePageClick = (data) => {
    setPage(data.selected + 1);
  };

  return (
    <div className='container-fluid'>
      <div className='row'>
        <div className='col-sm-12'>
          <div className='card'>
            <div className="portlet-body mx-3">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h4 className="mb-0">Company Discount List ({totalCount || "Loading..."})</h4>
                <Link className="btn btn-outline-dark btn-sm" to="/company-add-discount">
                  <i className="fa fa-plus"></i> Add Discount
                </Link>
              </div>
              <hr />
              <form className="form-horizontal mb-3" onSubmit={handleSearchSubmit}>
                <div className="row">
                  <div className="col-md-3">
                    <input
                      placeholder="Search..."
                      className="form-control"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                  </div>
                  <div className="col-md-3 d-flex">
                    <button className="btn btn-primary me-2" type="submit">Search</button>
                    <button className="btn btn-secondary" onClick={handleReset}>Reset</button>
                  </div>
                </div>
              </form>
              <div className="card-body">
                {loadings ? (
                  <Loader />
                ) : totalCount === 0 ? (
                  <div className="text-center">
                    <h5>No Company Data Found</h5>
                  </div>
                ) : (
                  <>
                    <div className="table-responsive">
                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            <th>Sr No</th>
                            <th>Company Name</th>
                            <th>Corporate Name</th>
                            <th>Discount(%)</th>
                            <th>Created By</th>
                            <th>Created At</th>
                            <th>Updated By</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredData.map((user, index) => (
                            <tr key={index}>
                              <td>{(page - 1) * Limit + index + 1}</td>
                              <td>{user.company_name || "-"}</td>
                              <td>{user.corporate_name || "-"}</td>
                              <td><input type="number" value={user.discount} onChange={(e) => {
                                const newData = [...filteredData];
                                newData[index].discount = e.target.value;
                                setFilteredData(newData);
                              }} className="form-control" /></td>
                              <td>{user.created_by}</td>
                              <td>{user.createdAt}</td>
                              <td>{user.updated_by}</td>
                              <td>
                                <button
                                  className="btn btn-sm btn-success me-2"
                                  onClick={() => handleUpdate(user)}
                                >
                                  Update
                                </button>

                                <button
                                  className="btn btn-sm btn-danger"
                                  onClick={() => handleDelete(user?._id, user?.company_discount_id)}
                                >
                                  Delete
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    <div className="pagination-container mt-4">
                      <ReactPaginate
                        previousLabel={'Previous'}
                        nextLabel={'Next'}
                        breakLabel={'...'}
                        pageCount={pageCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageClick}
                        containerClassName={'pagination'}
                        activeClassName={'active'}
                        forcePage={page - 1}
                      />
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Company;
